import { Text, View } from '@react-pdf/renderer';
import React from 'react';
import { withTranslation } from 'react-i18next';

import commonStyles from 'views/SpecificationDocument/DocumentView/Common/commonStyles';

import { Detail } from '../../../DetailsPage/Details';

function ComponentVariants({
  colors,
  sizes,
  hasOneVariantColorForAllSpecificationColors,
  hasOneVariantSizeForAllSpecificationSizes,
  variantColorForAllSpecificationColors,
  variantSizeForAllSpecificationSizes,
  t,
}) {
  return (
    <View style={{ display: 'flex', flexDirection: 'column', width: '45%' }}>
      <View>
        <Text style={commonStyles.sectionTitle}>{t('variants')}</Text>
      </View>
      {hasOneVariantColorForAllSpecificationColors && variantColorForAllSpecificationColors && (
        <View style={commonStyles.detailRow}>
          <Detail title="" description={t('same_color_variant')} width="25%" />
          <Detail title="" description={variantColorForAllSpecificationColors} width="75%" />
        </View>
      )}
      {!hasOneVariantColorForAllSpecificationColors &&
        (colors || []).filter(Boolean).map((color) => (
          <View key={color.id} style={commonStyles.detailRow}>
            <Detail
              title=""
              description={color?.modelSpecificationColor?.name || '-'}
              width="25%"
            />
            <Detail title="" description={color?.productVariantColor || '-'} width="75%" />
          </View>
        ))}
      {hasOneVariantSizeForAllSpecificationSizes && variantSizeForAllSpecificationSizes && (
        <View style={{ ...commonStyles.detailRow, marginTop: 5 }}>
          <Detail title="" description={t('same_size_variant')} width="25%" />
          <Detail title="" description={variantSizeForAllSpecificationSizes} width="75%" />
        </View>
      )}
      {!hasOneVariantSizeForAllSpecificationSizes && (
        <View style={{ marginTop: 5 }}>
          {(sizes || []).filter(Boolean).map((size) => (
            <View key={size.id} style={commonStyles.detailRow}>
              <Detail
                description={size?.modelSpecificationSize?.sizeName?.name || '-'}
                title=""
                width="25%"
              />
              <Detail width="75%" title="" description={size?.productVariantSize || '-'} />
            </View>
          ))}
        </View>
      )}
    </View>
  );
}

export default withTranslation('specification')(ComponentVariants);
